/* assets/shipping-protection.js — tiered Shipping Protection auto-add (STABLE v6.2.4 UK, 2026-10-22)
 * Product 16112114893182 ("Shipping Protection"). GBP ladder (cart subtotal in pounds):
 * Up to 49=GBP 1.49; 50-149=2.99; 150-299=4.99; 300-499=6.97; 500+=9.97.
 * v6.1: 1 exchange max per sync, no rebuilds, self-mutation guard, 3s cooldown,
 * passive fetch listener and one-pass last-position move. Same rules as USA/CA v6.2.
 * v6.2: protection forced LAST in cart. Since /cart/add.js inserts at the FRONT on
 * these stores, a bounded one-pass move re-adds merchandise (reverse order) after
 * protection, so checkout shows: [merchandise..., Shipping Protection]. Never
 * removes protection mid-move, max 2 attempts, cooldown-guarded. */
(function () {
  'use strict';
  var PRODUCT_ID = '16112114893182';
  var AUTO_ADD = true;
  /* v6.2.3: never touch carts containing these products. Their flows auto-add
   * companion lines (e.g. Ultrasonic Combo -> Pods) and our reposition/re-add
   * churn breaks those adds. For these carts protection is fully skipped. */
  var EXCLUDED_PRODUCTS = [];
  /* v6.2.4 UK: carts containing these products GET protection (auto-add + tier
   * swap) but are NEVER repositioned — the reposition re-add churn broke the
   * Petal Combo -> Pods companion add. Protection may sit at the front of the
   * cart for these carts; that is accepted. */
  var EXCLUDE_REPOSITION = ["8929662337267"];
  try {
    var el = document.querySelector('[data-shipping-protection]');
    if (el && el.getAttribute('data-shipping-protection') === 'off') AUTO_ADD = false;
    if (document.querySelector('[data-shipping-protection-optin]')) AUTO_ADD = true;
  } catch (e) {}
  var TIERS = [
    { min: 0.00, max: 49.99, variantId: 58143190352254 },
    { min: 50.00, max: 149.99, variantId: 58143190385022 },
    { min: 150.00, max: 299.99, variantId: 58143190417790 },
    { min: 300.00, max: 499.99, variantId: 58143190450558 },
    { min: 500.00, max: Infinity, variantId: 58143190483326 }
  ];
  function tierFor(subtotal) {
    for (var i = 0; i < TIERS.length; i++) {
      if (subtotal >= TIERS[i].min && subtotal <= TIERS[i].max) return TIERS[i];
    }
    return TIERS[TIERS.length - 1];
  }
  function lineAmount(it) { return (it.final_line_price != null ? it.final_line_price : it.line_price) / 100; }
  var nativeFetch = (window.fetch && window.fetch.bind(window)) || null;
  var selfMutation = false, busy = false, cooldownUntil = 0;
  function cool(ms) { cooldownUntil = Date.now() + ms; }
  function inCool() { return Date.now() < cooldownUntil; }
  function inCheckout() {
    try { return /\/checkout(\/|$)/i.test(window.location.pathname); } catch (e) { return false; }
  }
  function raw(url, opts) {
    var f = window.fetch, args = Array.prototype.slice.call(arguments);
    selfMutation = true;
    try { return f.apply(window, args); }
    finally { selfMutation = false; }
  }
  function getCart() {
    return raw('/cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function hasNoReposition(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (EXCLUDE_REPOSITION.indexOf(String(items[i].product_id)) !== -1) return true;
    }
    return false;
  }
  function settledState(cart) {
    // returns: 'settled' | 'empty' | 'add' | 'change' | 'remove'
    var items = (cart && cart.items) || [];
    var merch = 0, prot = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.product_id) === PRODUCT_ID) prot.push(it);
      else merch += lineAmount(it);
    }
    if (!items.length || merch <= 0) return prot.length ? 'remove' : 'settled';
    var want = String(tierFor(merch).variantId);
    if (!prot.length) return AUTO_ADD ? 'add' : 'settled';
    if (prot.length > 1) return 'change';
    if (String(prot[0].variant_id) !== want) return 'change';
    if (items.length > 1 && items[items.length - 1] !== prot[0] && !hasNoReposition(cart)) return 'reposition';
    return 'settled';
  }
  function repositionLast(cart) {
    // Put protection LAST without a full-cart rebuild: merchandise display order is
    // preserved by re-adding it in reverse (front-insert store). One remove call +
    // re-adds; protection never leaves the cart mid-move.
    var items = (cart && cart.items) || [];
    var merch = [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].product_id) !== PRODUCT_ID) merch.push(items[i]);
    }
    if (!merch.length) return Promise.resolve('done');
    var zero = {};
    for (var m = 0; m < merch.length; m++) zero[merch[m].key] = 0;
    var seq = raw('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: zero })
    });
    for (var k = merch.length - 1; k >= 0; k--) {
      (function (ln) {
        seq = seq.then(function () {
          var body = { id: ln.variant_id, quantity: ln.quantity };
          if (ln.properties && Object.keys(ln.properties).length) body.properties = ln.properties;
          return raw('/cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
        });
      })(merch[k]);
    }
    return seq.then(function () { return 'done'; });
  }
  function oneExchange(cart) {
    var items = (cart && cart.items) || [];
    var merch = 0, prot = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.product_id) === PRODUCT_ID) prot.push(it);
      else merch += lineAmount(it);
    }
    if (!items.length || merch <= 0) {
      var rm = {};
      for (var k = 0; k < prot.length; k++) rm[prot[k].key] = 0;
      if (!prot.length) return Promise.resolve('done');
      return raw('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: rm })
      }).then(function () { return 'done'; });
    }
    var want = tierFor(merch).variantId;
    if (!prot.length && AUTO_ADD) {
      return raw('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: want, quantity: 1 })
      }).then(function () { return 'done'; });
    }
    if (prot.length > 1) {
      var kill = {};
      for (var d = 1; d < prot.length; d++) kill[prot[d].key] = 0;
      return raw('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: kill })
      }).then(function () { return 'done'; });
    }
    // Exact one-shot swap via /cart/update.js: remove old key + add new variant in the
    // same payload. This preserves every other line's position and is a single atomic
    // exchange, so nothing can re-trigger mid-flight.
    var swap = {};
    swap[prot[0].key] = 0;
    swap[String(want)] = 1;
    return raw('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: swap })
    }).then(function () { return 'done'; });
  }
  function nudgeTheme() {
    try { if (typeof window.updateCartCounters === 'function') window.updateCartCounters(); } catch (e) {}
    try { if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') window.Shopify.onCartUpdate(); } catch (e) {}
    try { document.documentElement.dispatchEvent(new CustomEvent('shipping-protection:synced', { bubbles: true })); } catch (e) {}
  }
  function excludedCart(cart) {
    if (!EXCLUDED_PRODUCTS.length) return false;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (EXCLUDED_PRODUCTS.indexOf(String(items[i].product_id)) !== -1) return true;
    }
    return false;
  }
  function sync() {
    if (busy || selfMutation || inCool() || inCheckout() || !nativeFetch) return Promise.resolve(false);
    busy = true;
    return getCart().then(function (cart) {
      if (excludedCart(cart)) return false;
      var st = settledState(cart);
      if (st === 'settled') return false;
      if (st === 'reposition') return repositionLast(cart).then(function () { return true; });
      return oneExchange(cart).then(function () { return true; });
    }).then(function (changed) {
      busy = false;
      if (changed) {
        cool(3000);
        nudgeTheme();
        // Post-write re-check: guarantees the follow-up pass (e.g. reposition
        // after a tier add) runs even when the theme emits no cart events.
        setTimeout(function () { try { sync(); } catch (e) {} }, 3300);
        // Second pass: companion lines (combo -> pods) can land up to ~3-6s
        // after the combo add; re-check again so the tier accounts for them.
        setTimeout(function () { try { sync(); } catch (e) {} }, 6600);
      }
      return changed;
    }).catch(function (err) {
      busy = false;
      if (window.console && console.warn) console.warn('[sp] skipped:', err && err.message);
      return false;
    });
  }
  function schedule() {
    if (busy || selfMutation || inCool() || inCheckout()) return;
    setTimeout(sync, 1200);
  }
  if (window.fetch && nativeFetch) {
    window.fetch = function (input, init) {
      var u = '';
      try { u = String((input && (input.url || input)) || ''); } catch (e) {}
      var isMutation = /\/cart\/(add|update|change|clear)(\.js)?(\?|#|$)/i.test(u);
      var p;
      try { p = nativeFetch.apply(this, arguments); }
      catch (e) { throw e; }
      if (isMutation && !selfMutation) {
        p.then(function () { schedule(); }, function () { schedule(); });
      }
      return p;
    };
  }
  try {
    document.addEventListener('DOMContentLoaded', function () { schedule(); });
    document.addEventListener('cart:updated', function () { schedule(); });
    document.addEventListener('cart:refresh', function () { schedule(); });
    window.addEventListener('pageshow', function () { schedule(); });
  } catch (e) {}
  window.__spSync = sync;
  setTimeout(sync, 1500);
})();